import {useMemo} from 'react';
import {
  addCurrentOptionToGroupIfNeeded,
  getOxygenEntityInfo,
  getSimpleGroupedEntities
} from '../../utils/assigned-to-helpers';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';
import {ISSUE_PERMITTED_ACTIONS} from '../../constants/issue-types';

const getOxygenLists = ({issue, currentUserCompanyOxygenId, oxygen, users, companies, roles}) => {
  if (featureFlags.get(FEATURE_FLAGS.ISSUES_V2) && featureFlags.get(FEATURE_FLAGS.RESTRICT_ISSUE_ASSIGNEE_FIELD)) {
    const permittedActions = issue[ISSUE_ATTRIBUTE_NAMES.PERMITTED_ACTIONS];
    const canAssignToCreatorOrOwner = permittedActions.includes(ISSUE_PERMITTED_ACTIONS.ASSIGN_CREATOR_OR_OWNER);
    const canAssignToAnyone = permittedActions.includes(ISSUE_PERMITTED_ACTIONS.ASSIGN_ALL);
    const currentUserCompany = currentUserCompanyOxygenId && oxygen.companies[currentUserCompanyOxygenId];
    const canAssignToOwnCompany =
      permittedActions.includes(ISSUE_PERMITTED_ACTIONS.ASSIGN_SAME_COMPANY) && !!currentUserCompany;

    if (canAssignToAnyone) {
      return {users, companies, roles};
    }

    if (canAssignToOwnCompany) {
      return {
        users: users.filter(
          ({oxygenId, company}) =>
            (canAssignToCreatorOrOwner &&
              (oxygenId === issue[ISSUE_ATTRIBUTE_NAMES.CREATED_BY] ||
                oxygenId === issue[ISSUE_ATTRIBUTE_NAMES.OWNER_ID])) ||
            oxygenId === issue[ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO] ||
            company?.oxygenId === currentUserCompany.oxygenId
        ),
        roles: [],
        companies: [currentUserCompany]
      };
    }
    if (canAssignToCreatorOrOwner) {
      return {
        users: users.filter(
          ({oxygenId}) =>
            oxygenId === issue[ISSUE_ATTRIBUTE_NAMES.CREATED_BY] || oxygenId === issue[ISSUE_ATTRIBUTE_NAMES.OWNER_ID]
        ),
        roles: [],
        companies: []
      };
    }

    return {
      users: [],
      roles: [],
      companies: []
    };
  }
  return {users, roles, companies};
};
export const useAllowedAssignees = ({users, companies, roles, currentUser, oxygen, issue}) => {
  const oxygenId = currentUser?.company?.oxygenId;
  return useMemo(() => {
    const oxygenLists = getOxygenLists({
      issue,
      currentUserCompanyOxygenId: oxygenId,
      oxygen,
      users,
      companies,
      roles
    });
    return {
      options: getSimpleGroupedEntities(
        addCurrentOptionToGroupIfNeeded(
          oxygenLists,
          getOxygenEntityInfo(
            oxygen,
            issue[ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO_TYPE],
            issue[ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO]
          )
        )
      ),
      clearable:
        !featureFlags.get(FEATURE_FLAGS.ISSUES_V2) ||
        !featureFlags.get(FEATURE_FLAGS.RESTRICT_ISSUE_ASSIGNEE_FIELD) ||
        issue[ISSUE_ATTRIBUTE_NAMES.PERMITTED_ACTIONS].includes(ISSUE_PERMITTED_ACTIONS.CLEAR_ASSIGNEE)
    };
  }, [companies, oxygenId, issue, oxygen, roles, users]);
};
